import { EvaluationTypeEnum } from "../../../models/EvaluationTypes";
import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const getAcceptedSubjectExtensions = (evaluationType: string): string => {
  if (evaluationType === EvaluationTypeEnum.NOTEBOOK) {
    return ".zip";
  }
  if (evaluationType === EvaluationTypeEnum.HTML) {
    return ".html";
  }
  return ".html,.zip";
};

export const isValidSubjectFile = (file: File, evaluationType: string): boolean => {
  const filename = file.name.toLowerCase();
  if (evaluationType === EvaluationTypeEnum.NOTEBOOK) {
    return filename.endsWith(".zip");
  }
  if (evaluationType === EvaluationTypeEnum.HTML) {
    return filename.endsWith(".html");
  }
  return filename.endsWith(".html") || filename.endsWith(".zip");
};

export const createEvaluation = (
  payload: any,
  language: string,
  setLoading: Function,
  displayAlert: Function,
  setShowCreationModal: Function,
  resetSelection: Function,
  file: File
) => {
  setLoading(true);

  const formData = new FormData();
  formData.append("data", JSON.stringify(payload));
  formData.append("file", file);

  ApiService.post("evaluations", formData, {
    "Content-Type": "multipart/form-data",
  })
    .then((response) => {
      setShowCreationModal(false);
      displayAlert({
        type: "success",
        title: translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.DST_ALERT.SUCCESS.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.DST_ALERT.SUCCESS.OPEN_EVALUATION"),
            variant: "secondary",
            onClick: () => window.open(`/evaluation/${response.data.evaluation.id}`, "_blank"),
          },
          {
            label: translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.DST_ALERT.SUCCESS.CREATE_EVALUATION"),
            variant: "primary",
            onClick: () => setShowCreationModal(true),
          },
        ],
      });
      resetSelection();
    })
    .catch((error) => {
      console.error("Error creating evaluation:", error);
      setShowCreationModal(false);
      displayAlert({
        type: "danger",
        title: translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.DST_ALERT.ERROR.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.DST_ALERT.ERROR.TRY_AGAIN"),
            variant: "primary",
            onClick: () => setShowCreationModal(true),
          },
        ],
      });
    })
    .finally(() => setLoading(false));
};

export const fetchPrograms = (language: string, setPrograms: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((error) => {
      console.error("Error loading programs:", error);
      alert(translate(language, "PAGES.EVALUATIONS.CREATION_MODAL.ERRORS.FETCH_PROGRAMS"));
    })
    .finally(() => setLoading(false));
};
